import { render } from "./newfooter.vue?vue&type=template&id=e30167e2&scoped=true"
import script from "./newfooter.vue?vue&type=script&lang=js"
export * from "./newfooter.vue?vue&type=script&lang=js"

import "./newfooter.vue?vue&type=style&index=0&id=e30167e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e30167e2"]])

export default __exports__